import { type RowSelectionState } from '@tanstack/react-table'
import { CircleAlert } from 'lucide-react'
import { type Dispatch, type SetStateAction } from 'react'

import { OpacityTransitionEnterAndLeave } from '../OpacityTransition'

type RowSelectionCountDisplayProps = {
  numberOfSelectedItems: number
  setRowSelection: Dispatch<SetStateAction<RowSelectionState>>
  maxNumberOfSelectedItems: number
}

const RowSelectionCountDisplay = ({
  numberOfSelectedItems,
  setRowSelection,
  maxNumberOfSelectedItems,
}: RowSelectionCountDisplayProps) => {
  return (
    <div className='flex items-center justify-start space-x-2'>
      <OpacityTransitionEnterAndLeave visible={numberOfSelectedItems > 0}>
        <div className='flex items-center justify-start p-2 gap-x-2 text-sm font-light border rounded-md bg-gray-200 w-full'>
          <div>{numberOfSelectedItems} items selected</div>
          <div
            className='cursor-pointer underline font-semibold'
            onClick={() => setRowSelection({})}
          >
            Deselect all?
          </div>
        </div>
      </OpacityTransitionEnterAndLeave>
      <OpacityTransitionEnterAndLeave
        visible={numberOfSelectedItems >= maxNumberOfSelectedItems}
      >
        <div className='flex items-center justify-start p-2 gap-x-2 text-sm font-light border rounded-md border-red-200 bg-red-100 w-full'>
          <CircleAlert size={16} className='stroke-red-600' />
          <div>Selected items limit reached!</div>
        </div>
      </OpacityTransitionEnterAndLeave>
    </div>
  )
}

export default RowSelectionCountDisplay
